module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--alexa-b8571610.png";